// Admin: список и редактирование notification_templates.

import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { adminNotificationsAPI, AdminNotificationTemplate } from '../services/notificationsAPI';

const NotificationTemplatesPage: React.FC = () => {
  const [items, setItems] = useState<AdminNotificationTemplate[]>([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState<AdminNotificationTemplate | null>(null);

  const refresh = async () => {
    try {
      setLoading(true);
      const data = await adminNotificationsAPI.listTemplates();
      setItems(data);
    } catch (e) {
      toast.error('Не удалось загрузить шаблоны');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const handleSave = async () => {
    if (!editing) return;
    try {
      await adminNotificationsAPI.upsertTemplate(editing);
      toast.success('Шаблон сохранён');
      setEditing(null);
      refresh();
    } catch {
      toast.error('Не удалось сохранить');
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 960 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>Шаблоны уведомлений</h1>

      {loading && <div>Загрузка…</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8, fontSize: 13, fontWeight: 600, padding: '8px 0', borderBottom: '1px solid #e5e7eb' }}>
        <div>template_key</div>
        <div>event_type</div>
        <div>severity</div>
        <div>actions</div>
      </div>
      {items.map((t) => (
        <div
          key={t.template_key}
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gap: 8,
            fontSize: 13,
            padding: '8px 0',
            borderBottom: '1px solid #f3f4f6',
            opacity: t.enabled ? 1 : 0.5,
          }}
        >
          <div>{t.template_key}</div>
          <div>{t.event_type || '—'}</div>
          <div>{t.severity}</div>
          <div>
            <button
              type="button"
              onClick={() => setEditing({ ...t })}
              style={{ background: 'transparent', border: 0, color: '#2563eb', cursor: 'pointer' }}
            >
              изменить
            </button>
          </div>
        </div>
      ))}

      {editing && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, width: 560, maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{editing.template_key}</h2>

            <label style={{ display: 'block', marginBottom: 10 }}>
              <span style={{ fontSize: 13 }}>Заголовок (template)</span>
              <input
                type="text"
                value={editing.title_tpl}
                onChange={(e) => setEditing({ ...editing, title_tpl: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
              />
            </label>

            <label style={{ display: 'block', marginBottom: 10 }}>
              <span style={{ fontSize: 13 }}>Текст (template)</span>
              <textarea
                value={editing.body_tpl}
                onChange={(e) => setEditing({ ...editing, body_tpl: e.target.value })}
                rows={3}
                style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, fontFamily: 'inherit' }}
              />
            </label>

            <label style={{ display: 'block', marginBottom: 10 }}>
              <span style={{ fontSize: 13 }}>Ссылка (template, опционально)</span>
              <input
                type="text"
                value={editing.link_tpl || ''}
                onChange={(e) => setEditing({ ...editing, link_tpl: e.target.value || null })}
                style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
              />
            </label>

            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: 16 }}>
              <input
                type="checkbox"
                checked={editing.enabled}
                onChange={(e) => setEditing({ ...editing, enabled: e.target.checked })}
              />
              <span style={{ fontSize: 14 }}>Включён</span>
            </label>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <button
                type="button"
                onClick={() => setEditing(null)}
                style={{ padding: '8px 12px', background: '#fff', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer' }}
              >
                Отмена
              </button>
              <button
                type="button"
                onClick={handleSave}
                style={{ padding: '8px 12px', background: '#2563eb', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer' }}
              >
                Сохранить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationTemplatesPage;
